import React, { useState } from 'react'
import SearchBolig from '../components/BoligPrisKalkulator/SearchBolig'
import SearchBoligLight from '../components/BoligPrisKalkulator/SearchBoligLight'

function BoligPrisKalkulatorPage() {

    const [activeItem, setActiveItem] = useState("1");

    function toggle(tab) {
        if (activeItem !== tab) {
            setActiveItem(tab);
        }
    }

    return (
        <div className="container my-3">
            <div className="row my-4">
                <div className="col-6">
                    <button className="btn btn-block btn-primary" onClick={() => toggle("1")}>Hurtigsøk</button>
                </div>
                <div className="col-6">
                    <button className="btn btn-block btn-primary" onClick={() => toggle("2")}>Avansert søk</button>
                </div>
            </div>
            {activeItem === "1" && (
                <React.Fragment>
                    <h4 className="text-center font-weight-bold">Hurtigsøk</h4>
                    <SearchBoligLight />
                </React.Fragment>
            )}
            {activeItem === "2" && (
                <React.Fragment>
                    <h4 className="text-center font-weight-bold">Avansert søk</h4>
                    <SearchBolig />
                </React.Fragment>
            )}


        </div>
    )

}
export default BoligPrisKalkulatorPage